/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-12 17:19:48
 * @Description: 新建用户
 */
"use strict";
angular.module("addUsersForRoleModule", []).
controller("addUsersForRoleCtrl", ["$scope", "$modalInstance", "httpService", "roleId", "modalDialog", function ($scope, $modalInstance, httpService, roleId, modalDialog) {
	initStatus();
	initData();

	function initStatus() {
		$scope.status = {
			treeOptions: {
				nodeChildren: "children",
				dirSelectable: true,
				allowDeselect: false,
				injectClasses: {
					ul: "a1",
					li: "a2",
					liSelected: "a7",
					iExpanded: "a3",
					iCollapsed: "a4",
					iLeaf: "a5",
					label: "a6",
					labelSelected: "rolegrouplabselected"
				},
				isLeaf: function (node) {
					return node.children == null;
				},
				isSelectable: function (node) {
					return node.groupDN !== '1';
				}
			},
		}
		$scope.data = {
			treeData: [], //组织数据
			uesrData: [], //选择列表
			userCopyData: [], //已选择的数据
			selectData: [], //已选列表
			selectCopyData: [], //已选列表选择的数据
			searchVal: '', //选择列表搜索框
			groudId: '', //当前选中组织的groupId
			roleId: roleId
		}
	}

	function initData() {
		requestData();
		$scope.$watch('data.searchVal', function (newVal, oldVal) {
			if ($scope.data.groudId == '') return;
			httpService.http('/mcnadmin/admin/group/queryUsersByGrpId.do', {
				groupId: $scope.data.groudId,
				userName: newVal
			}, 'get').then(function (res) {
				if ($scope.data.selectData.length == 0) {
					$scope.data.uesrData = res.data;
				} else {
					for (var i = 0; i < res.data.length; i++) {
						for (var k = 0; k < $scope.data.selectData.length; k++) {
							if (res.data[i] != undefined) {
								if (res.data[i].id === $scope.data.selectData[k].id) {
									res.data.splice(i, 1);
								}
							}
						}
					}
					$scope.data.uesrData = res.data;
				}
			})
		})
	}

	function requestData() {
		httpService.http('/mcnadmin/admin/group/findGroups.do', {
			'groudId': -1
		}, 'get').then(function (res) {
			$scope.data.treeData = [res.data[0]];
		})
	}
	/**
	 * 
	 * @param {*} node
	 * 点击组织节点请求数据加载到选择列表 
	 */
	$scope.showSelected = function (node) {
		$scope.data.groudId = node.groupId;
		httpService.http('/mcnadmin/admin/group/queryUsersByGrpId.do', {
			groupId: node.groupId
		}, 'get').then(function (res) {
			if ($scope.data.selectData.length == 0) {
				$scope.data.uesrData = res.data;
			} else {
				for (var i = 0; i < res.data.length; i++) {
					for (var k = 0; k < $scope.data.selectData.length; k++) {
						if (res.data[i] != undefined) {
							if (res.data[i].id === $scope.data.selectData[k].id) {
								res.data.splice(i, 1);
							}
						}
					}
				}
				$scope.data.uesrData = res.data;
			}
			$scope.data.uesrData = res.data;
		})
	}
	//点击展开按钮时可以显示下一层子集结构
	$scope.showToggle = function (node) {
		httpService.http('/mcnadmin/admin/group/findGroups.do', {
			groupId: node.groupId
		}, 'get').then(function (res) {
			if (res.data.length == 0) return;
			else {
				node.children = res.data;
			}
		})
	}
	/**
	 * 
	 * @param {*} item
	 * 点击选择列表数据判定是否选择
	 */
	$scope.selectList = function (item) {
		var index = $scope.data.userCopyData.indexOf(item);
		if (index == -1) {
			$scope.data.userCopyData.push(item);
		} else {
			$scope.data.userCopyData.splice(index, 1);
		}
	}
	/**
	 * 点击选择把选择列表已选数据添加到已选列表
	 */
	$scope.selectClick = function () {
		if ($scope.data.userCopyData.length == 0) return;
		var index = 0;
		for (var i = 0; i < $scope.data.userCopyData.length; i++) {
			index = $scope.data.uesrData.indexOf($scope.data.userCopyData[i]);
			$scope.data.selectData.push($scope.data.uesrData.splice(index, 1)[0]);
		}
		$scope.data.userCopyData = [];
	}
	/**
	 * 
	 * @param {*} item
	 * 判定已选列表的数据是否选择 
	 */
	$scope.selectedList = function (item) {
		var index = $scope.data.selectCopyData.indexOf(item);
		if (index == -1) {
			$scope.data.selectCopyData.push(item);
		} else {
			$scope.data.selectCopyData.splice(index, 1);
		}
	}
	/**
	 * 撤销
	 */
	$scope.undoClick = function () {
		if ($scope.data.selectCopyData.length == 0) return;
		var index = 0;
		for (var i = 0; i < $scope.data.selectCopyData.length; i++) {
			index = $scope.data.selectData.indexOf($scope.data.selectCopyData[i]);
			$scope.data.uesrData.push($scope.data.selectData.splice(index, 1)[0]);
		}
		$scope.data.selectCopyData = [];
	}
	/**
	 * 全选
	 */
	$scope.selectAll = function () {
		if ($scope.data.uesrData.length == 0) return;
		var arr = $scope.data.uesrData.splice(0, $scope.data.uesrData.length);
		for (var i = 0; i < arr.length; i++) {
			$scope.data.selectData.push(arr[i]);
		}
	}
	/**
	 * 全撤
	 */
	$scope.fullWithdrawal = function () {
		if ($scope.data.selectData.length == 0) return;
		var arr = $scope.data.selectData.splice(0, $scope.data.selectData.length);
		for (var i = 0; i < arr.length; i++) {
			$scope.data.uesrData.push(arr[i]);
		}
	}
	/**
	 * 取消按钮
	 */
	$scope.cancel = function () {
		$modalInstance.dismiss();
	};
	/**
	 * 确定
	 */
	$scope.confirm = function () {
		if ($scope.data.selectData.length == 0) {
			modalDialog.alertType('', '请选择用户', 'info');
			return;
		}
		var arr = [];
		for (var i = 0; i < $scope.data.selectData.length; i++) {
			arr.push($scope.data.selectData[i].id);
		}
		httpService.http('/mcnadmin/admin/role/addRoleUsers.do', {
			roleId: $scope.data.roleId,
			userIds: arr.join()
		}, 'post').then(function (res) {
			if (res.success) modalDialog.alertType('', '选择用户成功', 'success');
			$modalInstance.close(res.success);
		})

	};
}]);